import { IncomingWebhook } from '@slack/webhook';
import { getServerRuntimeConfig } from '../../common/config';
import logger from './logger';

const slack = {
  sendToSlack: async (title: string, body: string) => {
    const { slackWebhookUrl, slackChannel } = getServerRuntimeConfig();
    const webhook = new IncomingWebhook(slackWebhookUrl);
    try {
      await webhook.send({
        channel: slackChannel,
        username: title,
        text: body,
        icon_emoji: ':slide:',
      });
    } catch (e) {
      logger.warn(e);
    }
  },
};

export default slack;
